module.exports = __webpack_public_path__ + "static/img/2.789f8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/2.png
// module id = paho
// module chunks = 19